import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';

export const DealerQuestionTop = () => {
  const helpIcon = findIcon(IconName.help);
  const icon = findIcon(IconName.man);

  return (
    <>
      <div className="dealerQuestionTop">
        <CardLabel
          letter="&#10102; 代表者様を取引担当者様としますか？"
          sentence="代表者様とは別の方を取引担当者様とする場合"
          sentenceIcon={helpIcon}
          help={
            <>
              代表者様から取引担当者様への
              <a target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_POWER_OF_ATTORNEY_URL}>
                権限委任状
              </a>
              をご提出いただきます。
            </>
          }
        />
        <SvgIcon icon={icon} size={IconSize.icon_xl} />
      </div>
    </>
  );
};

interface DealerQuestionBottomProps {
  selected: boolean | null;
  onChange: (selected: boolean) => void;
  error: string | undefined;
}

export const DealerQuestionBottom = (props: DealerQuestionBottomProps) => {
  return (
    <>
      <div className="dealerQuestionBottom">
        <TwoSelections name="DealerQuestion" {...props} />
      </div>
    </>
  );
};
